define('OutSystems/ClientRuntime/Navigation',["require", "exports", "path-to-regexp", "./ApplicationInfo", "./Exceptions", "./Flow", "./Logger", "./modules/Common/IndexedStack", "./RegExpHelper", "./Settings"], function (require, exports, pathToRegexp, ApplicationInfo, Exceptions_1, Flow, Logger, IndexedStack_1, RegExpHelper_1, Settings_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.VersionedURL = exports.buildApplicationRelativeUrl = exports.generateScreenURL = exports.locationReachedFromHistory = exports.ensureRequestSecurity = exports.switchUrlProtocol = exports.navigateBackNumPages = exports.navigateForwardNumPages = exports.navigateForward = exports.navigateBack = exports.navigateTo = exports.urlBelongsToPrefix = exports.onBeforeNavigate = exports.getUrlInfo = exports.unregisterBackNavigationHandler = exports.registerBackNavigationHandler = exports.reloadCurrentLocation = exports.reloadApplication = exports.addInvalidationSuffixToUrl = exports.currentLocationHasTimestamp = exports.changeWindowLocation = exports.hasPendingReload = exports.getLocationFromUrl = exports.urlBelongsToCurrentApplication = exports.getSearchParameterValue = exports.getCurrentLocation = exports.resetReloadState = exports.willReloadInNextNavigation = exports.forceReloadOnNextNavigation = exports.removeNavigationCallbacks = exports.getNavigationCallbacks = exports.setNavigationCallbacks = exports.throwRedirectOccurredExceptionIfNeeded = exports.isValidContext = exports.validateContext = exports.SCREEN_URL_PART_SEPARATOR = exports.NAVIGATE_FROM_HISTORY_ACTION = exports.NAVIGATE_TO_URL_ACTION = void 0;
    var NAVIGATION_MODULE_NAME = "Navigation";
    var FIRST_NODE_REGEX = new RegExp("/([^/]*)");
    var DOUBLE_SLASH_REGEX = new RegExp(/\/(\/)+/gm);
    var CONTAINS_SLASH_START_END_REGEX = new RegExp(/^\/|\/$/g);
    var QUERY_SEPARATOR = "?";
    var HASH_SEPARATOR = "#";
    var PARAMS_SEPARATOR = "&";
    var TIMESTAMP_QUERYPARAM = "_ts";
    var RECURSIVE_REDIRECTS_MAX_COUNT = 10;
    var RECURSIVE_REDIRECTS_PERIOD_IN_MS = 1000;
    exports.NAVIGATE_TO_URL_ACTION = "PUSH";
    exports.NAVIGATE_FROM_HISTORY_ACTION = "POP";
    exports.SCREEN_URL_PART_SEPARATOR = "-";
    var lastNavigatedUrls = [];
    var navigationCallbacks = [];
    var navigationHandlerStack = new IndexedStack_1.default();
    function validateContext(callContext) {
        if (!isValidContext(callContext)) {
            throw new Exceptions_1.Exceptions.OutOfContextException();
        }
    }
    exports.validateContext = validateContext;
    function isValidContext(callContext) {
        if (!!callContext && callContext.isOutOfContext) {
            return false;
        }
        return true;
    }
    exports.isValidContext = isValidContext;
    function throwRedirectOccurredExceptionIfNeeded(interruptExecution) {
        if (interruptExecution) {
            throw new Exceptions_1.Exceptions.RedirectOccurredException();
        }
    }
    exports.throwRedirectOccurredExceptionIfNeeded = throwRedirectOccurredExceptionIfNeeded;
    function setNavigationCallbacks(newNavigationCallBacks) {
        navigationCallbacks.push(newNavigationCallBacks);
    }
    exports.setNavigationCallbacks = setNavigationCallbacks;
    function getNavigationCallbacks() {
        return navigationCallbacks[navigationCallbacks.length - 1];
    }
    exports.getNavigationCallbacks = getNavigationCallbacks;
    function removeNavigationCallbacks() {
        return navigationCallbacks.pop();
    }
    exports.removeNavigationCallbacks = removeNavigationCallbacks;
    function validateValueNotNegative(value, argName) {
        if (argName === void 0) { argName = "Value"; }
        if ((!value && value !== 0) || value < 0) {
            throw new Exceptions_1.Exceptions.Exception("Couldn't perform the page navigation because \"".concat(value, "\" is not valid. ").concat(argName, " needs to be greater than or equal to 0."));
        }
    }
    var forceReload = false;
    var useTimestampOnReload = false;
    function forceReloadOnNextNavigation(useTimestamp) {
        if (useTimestamp === void 0) { useTimestamp = false; }
        Logger.trace(NAVIGATION_MODULE_NAME, "Next navigation will force a reload...");
        forceReload = true;
        useTimestampOnReload = useTimestamp;
    }
    exports.forceReloadOnNextNavigation = forceReloadOnNextNavigation;
    function willReloadInNextNavigation() {
        return forceReload;
    }
    exports.willReloadInNextNavigation = willReloadInNextNavigation;
    function resetReloadState(forceReloadValue, useTimestampOnReloadValue) {
        if (forceReloadValue === void 0) { forceReloadValue = false; }
        if (useTimestampOnReloadValue === void 0) { useTimestampOnReloadValue = false; }
        forceReload = forceReloadValue;
        useTimestampOnReload = useTimestampOnReloadValue;
    }
    exports.resetReloadState = resetReloadState;
    var getCurrentLocation = function () {
        var _a;
        var protocol = (_a = window.location, _a.protocol), pathname = _a.pathname, href = _a.href, search = _a.search;
        var hostname = window.location.hostname || window.location.host.split(":")[0];
        return {
            protocol: protocol,
            pathname: pathname,
            href: href,
            search: search,
            hostname: hostname,
        };
    };
    exports.getCurrentLocation = getCurrentLocation;
    var getSearchParameterValue = function (key) {
        if (key === undefined) {
            return null;
        }
        var urlQuery = window.location.search.substring(1);
        var queryParams = getQueryParameterParts(urlQuery);
        return queryParams[key];
    };
    exports.getSearchParameterValue = getSearchParameterValue;
    var urlBelongsToCurrentApplication = function (urlInfo, _a) {
        var _b;
        var _c = _a === void 0 ? {} : _a, _d = _c.getLocation, getLocation = _d === void 0 ? exports.getCurrentLocation : _d, _e = _c.getBasePath, getBasePath = _e === void 0 ? ApplicationInfo.getBasePath : _e, _f = _c.getHomeModuleDefinition, getHomeModuleDefinition = _f === void 0 ? ApplicationInfo.getHomeModuleDefinition : _f;
        var isWebProtocol = urlInfo.protocol === "http:" || urlInfo.protocol === "https:" || urlInfo.protocol === "outsystems:";
        if (!isWebProtocol) {
            return false;
        }
        var currentHost = getLocation().hostname;
        var host = urlInfo.hostname !== "" ? urlInfo.hostname : currentHost;
        if (currentHost !== host) {
            return false;
        }
        if ((0, Settings_1.getEnvParams)().AllowInterAppNavigationWhenAppIsRoot) {
            var pathname = (_b = urlInfo.pathname) === null || _b === void 0 ? void 0 : _b.replace(/\/$/, "");
            if (!urlBelongsToPrefix(pathname, getBasePath(), getHomeModuleDefinition(), { getBasePath: getBasePath })) {
                return false;
            }
        }
        else {
            var firstNodePath = FIRST_NODE_REGEX.exec(urlInfo.pathname);
            if (!firstNodePath || firstNodePath.length < 2) {
                return false;
            }
        }
        var belongsToApp = new RegExp("^".concat((0, RegExpHelper_1.escape)(getBasePath())), "i");
        return belongsToApp.test("".concat(urlInfo.pathname, "/"));
    };
    exports.urlBelongsToCurrentApplication = urlBelongsToCurrentApplication;
    var getLocationFromUrl = function (url) {
        var urlElement = document.createElement("a");
        urlElement.href = url;
        return urlElement;
    };
    exports.getLocationFromUrl = getLocationFromUrl;
    var hasPendingChangeWindowLocation = false;
    function hasPendingReload() {
        return hasPendingChangeWindowLocation;
    }
    exports.hasPendingReload = hasPendingReload;
    var changeWindowLocation = function (url, addTimestamp, replaceHistory) {
        if (addTimestamp === void 0) { addTimestamp = false; }
        if (replaceHistory === void 0) { replaceHistory = false; }
        if (addTimestamp) {
            url = addInvalidationSuffixToUrl(url);
        }
        Logger.trace(NAVIGATION_MODULE_NAME, "Reloading application with url: '".concat(url, "' (replace = ").concat(replaceHistory, ")"));
        var redirect = function () {
            if (replaceHistory) {
                window.location.replace(url);
            }
            else {
                window.location.href = url;
            }
        };
        hasPendingChangeWindowLocation = true;
        Logger.flushLogsToStorage(true).then(redirect).catch(redirect);
    };
    exports.changeWindowLocation = changeWindowLocation;
    function currentLocationHasTimestamp() {
        return typeof window !== "undefined" && window.location.search.indexOf(TIMESTAMP_QUERYPARAM) >= 0;
    }
    exports.currentLocationHasTimestamp = currentLocationHasTimestamp;
    function addInvalidationSuffixToUrl(url) {
        var appendType = url.indexOf(QUERY_SEPARATOR) < 0 ? QUERY_SEPARATOR : PARAMS_SEPARATOR;
        var timestampParam = "".concat(appendType).concat(TIMESTAMP_QUERYPARAM, "=").concat(new Date().valueOf());
        var hashIndex = url.indexOf(HASH_SEPARATOR);
        if (hashIndex >= 0) {
            return [url.slice(0, hashIndex), timestampParam, url.slice(hashIndex)].join("");
        }
        else {
            return "".concat(url).concat(timestampParam);
        }
    }
    exports.addInvalidationSuffixToUrl = addInvalidationSuffixToUrl;
    function reloadApplication(addTimestamp) {
        if (addTimestamp === void 0) { addTimestamp = false; }
        var newLocation = buildApplicationRelativeUrl();
        (0, exports.changeWindowLocation)(newLocation, addTimestamp);
    }
    exports.reloadApplication = reloadApplication;
    function reloadCurrentLocation(addTimestamp) {
        if (addTimestamp === void 0) { addTimestamp = false; }
        (0, exports.changeWindowLocation)((0, exports.getCurrentLocation)().href, addTimestamp, true);
    }
    exports.reloadCurrentLocation = reloadCurrentLocation;
    function concatApplicationToRelativeURL(url) {
        return buildApplicationRelativeUrl([ApplicationInfo.getBasePath(), url]);
    }
    function isRecursiveNavigation(url) {
        var currentTimestamp = new Date().getTime();
        var minPeriodDate = currentTimestamp - RECURSIVE_REDIRECTS_PERIOD_IN_MS;
        while (lastNavigatedUrls.length > 0 && lastNavigatedUrls[0].timestamp < minPeriodDate) {
            lastNavigatedUrls.shift();
        }
        var countRepeatedNavigations = lastNavigatedUrls.reduce(function (previous, value) {
            return value.url === url ? previous + 1 : previous;
        }, 0);
        if (countRepeatedNavigations < RECURSIVE_REDIRECTS_MAX_COUNT) {
            lastNavigatedUrls.push({ timestamp: currentTimestamp, url: url });
            return false;
        }
        else {
            Logger.trace(NAVIGATION_MODULE_NAME, "Identified a recursive navigation to '" + url + "'.");
            return true;
        }
    }
    function registerBackNavigationHandler(callback) {
        return navigationHandlerStack.push(callback);
    }
    exports.registerBackNavigationHandler = registerBackNavigationHandler;
    function unregisterBackNavigationHandler(id) {
        navigationHandlerStack.remove(id);
    }
    exports.unregisterBackNavigationHandler = unregisterBackNavigationHandler;
    var getUrlInfo = function (url, _a) {
        var _b = _a === void 0 ? {} : _a, _c = _b.getHomeModuleDefinition, getHomeModuleDefinition = _c === void 0 ? ApplicationInfo.getHomeModuleDefinition : _c;
        var isInternalUrl = false;
        var urlHash;
        var urlQuery = "";
        var urlPath = url;
        var isAbsoluteUrl = url.indexOf(":") !== -1 ||
            url.indexOf("/") === 0;
        var urlHashIndex = urlPath.indexOf(HASH_SEPARATOR);
        if (urlHashIndex !== -1) {
            urlHash = urlPath.substring(urlHashIndex + 1).trim();
            urlPath = urlPath.substring(0, urlHashIndex);
        }
        var urlQueryIndex = urlPath.indexOf(QUERY_SEPARATOR);
        if (urlQueryIndex !== -1) {
            urlQuery = urlPath.substring(urlQueryIndex + 1).trim();
            urlPath = urlPath.substring(0, urlQueryIndex);
        }
        if (isAbsoluteUrl) {
            var absoluteUrlInfo = (0, exports.getLocationFromUrl)(urlPath);
            isInternalUrl = (0, exports.urlBelongsToCurrentApplication)(absoluteUrlInfo, { getHomeModuleDefinition: getHomeModuleDefinition });
            if (isInternalUrl) {
                urlPath = absoluteUrlInfo.pathname;
            }
        }
        else {
            urlPath = concatApplicationToRelativeURL(urlPath);
            isInternalUrl = true;
        }
        var queryParams = getQueryParameterParts(urlQuery);
        return {
            url: url,
            isInternal: isInternalUrl,
            path: urlPath,
            queryParams: queryParams,
            hash: urlHash,
        };
    };
    exports.getUrlInfo = getUrlInfo;
    function getQueryParameterParts(urlQuery) {
        var queryParams = Object.create(null);
        if (urlQuery.length > 0) {
            urlQuery.split(PARAMS_SEPARATOR).forEach(function (param) {
                var paramParts = param.split("=");
                if (paramParts.length === 2) {
                    var key = safeDecodeURIComponent(paramParts[0]);
                    var value = safeDecodeURIComponent(paramParts[1]);
                    queryParams[key] = value;
                }
            });
        }
        return queryParams;
    }
    function safeDecodeURIComponent(encodedText) {
        return decodeURIComponent(encodedText.replace(/\+/g, " "));
    }
    function onBeforeNavigate(nextLocation, isBackNavigation) {
        var forceReloadOnNavigation = forceReload;
        if (forceReload) {
            forceReload = false;
        }
        if (isBackNavigation && !navigationHandlerStack.isEmpty) {
            var handler = navigationHandlerStack.pop();
            Flow.tryCatch(handler, function (e) {
                Logger.error(ApplicationInfo.getHomeModuleName(), e);
            });
            return false;
        }
        var fromHistory = locationReachedFromHistory(nextLocation);
        if (fromHistory || forceReloadOnNavigation) {
            var urlInfo = (0, exports.getUrlInfo)(nextLocation.pathname);
            var modules = ApplicationInfo.getModules();
            var basePath = ApplicationInfo.getBasePath();
            var invalidInternalURL = void 0;
            if (urlInfo.isInternal) {
                invalidInternalURL = true;
                for (var moduleKey in modules) {
                    if (modules.hasOwnProperty(moduleKey)) {
                        var path = urlInfo.url.replace(/\/$/, "");
                        var module = modules[moduleKey];
                        if (urlBelongsToPrefix(path, buildApplicationRelativeUrl([basePath]), module) ||
                            (module.moduleName !== ApplicationInfo.getHomeModuleName() &&
                                urlBelongsToPrefix(path, module.moduleName, module))) {
                            invalidInternalURL = false;
                            break;
                        }
                    }
                }
            }
            else {
                invalidInternalURL = false;
            }
            if (forceReloadOnNavigation || invalidInternalURL) {
                var newLocation = void 0;
                if (invalidInternalURL) {
                    newLocation = buildApplicationRelativeUrl();
                }
                else {
                    var search = nextLocation.search || "";
                    if (basePath === nextLocation.pathname && search === "") {
                        newLocation = /\/$/.test(nextLocation.pathname)
                            ? nextLocation.pathname
                            : "".concat(nextLocation.pathname, "/");
                    }
                    else {
                        newLocation = nextLocation.pathname + search;
                    }
                }
                (0, exports.changeWindowLocation)(newLocation, useTimestampOnReload, fromHistory);
                return !invalidInternalURL;
            }
        }
        navigationHandlerStack.clear();
        return true;
    }
    exports.onBeforeNavigate = onBeforeNavigate;
    function urlBelongsToPrefix(path, prefix, module, _a) {
        var _b = _a === void 0 ? {} : _a, _c = _b.getBasePath, getBasePath = _c === void 0 ? ApplicationInfo.getBasePath : _c;
        return (prefix.replace(/\/$/, "") === path ||
            module.screens.some(function (screen) {
                var appRelativeUrl = buildApplicationRelativeUrl([prefix, screen.screenUrl], { getBasePath: getBasePath });
                var regexp = pathToRegexp.pathToRegexp(appRelativeUrl);
                return regexp.test(path);
            }));
    }
    exports.urlBelongsToPrefix = urlBelongsToPrefix;
    function cancelAllPendingResources() {
        if (ApplicationInfo.isWebApplication() && window.stop && document.readyState === "complete") {
            Logger.trace(NAVIGATION_MODULE_NAME, "Stopping all currently pending resources.");
            window.stop();
        }
    }
    function navigateTo(url, transition, callContext, interruptExecution, replace) {
        validateContext(callContext);
        if (isRecursiveNavigation(url)) {
            throw Error("Too many redirects.");
        }
        if (!interruptExecution) {
            cancelAllPendingResources();
        }
        var urlInfo = (0, exports.getUrlInfo)(url);
        var callbacks = getNavigationCallbacks();
        if ((callbacks === null || callbacks === void 0 ? void 0 : callbacks.goTo) && urlInfo.isInternal) {
            callbacks.goTo(urlInfo, transition, replace);
        }
        else {
            (0, exports.changeWindowLocation)(url);
        }
        throwRedirectOccurredExceptionIfNeeded(interruptExecution);
    }
    exports.navigateTo = navigateTo;
    function navigateBack(transition, callContext, interruptExecution) {
        validateContext(callContext);
        if (!interruptExecution) {
            cancelAllPendingResources();
        }
        var callbacks = getNavigationCallbacks();
        if (callbacks === null || callbacks === void 0 ? void 0 : callbacks.goBack) {
            callbacks.goBack(transition);
        }
        else {
            window.history.back();
        }
        throwRedirectOccurredExceptionIfNeeded(interruptExecution);
    }
    exports.navigateBack = navigateBack;
    function navigateForward(transition, callContext, interruptExecution) {
        validateContext(callContext);
        if (!interruptExecution) {
            cancelAllPendingResources();
        }
        var callbacks = getNavigationCallbacks();
        if (callbacks === null || callbacks === void 0 ? void 0 : callbacks.goForward) {
            callbacks.goForward(transition);
        }
        else {
            window.history.forward();
        }
        throwRedirectOccurredExceptionIfNeeded(interruptExecution);
    }
    exports.navigateForward = navigateForward;
    function navigateForwardNumPages(numPages, transition, callContext, interruptExecution) {
        validateValueNotNegative(numPages, "NumPages");
        navigateByOffset(numPages, transition, callContext, interruptExecution);
    }
    exports.navigateForwardNumPages = navigateForwardNumPages;
    function navigateBackNumPages(numPages, transition, callContext, interruptExecution) {
        validateValueNotNegative(numPages, "NumPages");
        navigateByOffset(-numPages, transition, callContext, interruptExecution);
    }
    exports.navigateBackNumPages = navigateBackNumPages;
    function navigateByOffset(numPages, transition, callContext, interruptExecution) {
        validateContext(callContext);
        if (!interruptExecution) {
            cancelAllPendingResources();
        }
        var callbacks = getNavigationCallbacks();
        if (callbacks === null || callbacks === void 0 ? void 0 : callbacks.goOffset) {
            callbacks.goOffset(numPages, transition);
        }
        else {
            window.history.go(numPages);
        }
        throwRedirectOccurredExceptionIfNeeded(interruptExecution);
    }
    function switchUrlProtocol(url, oldProtocol, newProtocol) {
        return newProtocol + url.substring(oldProtocol.length);
    }
    exports.switchUrlProtocol = switchUrlProtocol;
    function ensureRequestSecurity() {
        var currentLocation = (0, exports.getCurrentLocation)();
        if (currentLocation.protocol.toLocaleLowerCase() === "http:") {
            if (currentLocation.hostname.toLocaleLowerCase() === "localhost") {
                Logger.log("Navigation", "Accessing through http://localhost is not supported. Please access the application using the hostname instead.");
            }
            else {
                var secureURL = switchUrlProtocol(currentLocation.href, currentLocation.protocol, "https:");
                (0, exports.changeWindowLocation)(secureURL, false, true);
                return true;
            }
        }
        return false;
    }
    exports.ensureRequestSecurity = ensureRequestSecurity;
    function locationReachedFromHistory(location) {
        return location.action.toUpperCase() === exports.NAVIGATE_FROM_HISTORY_ACTION;
    }
    exports.locationReachedFromHistory = locationReachedFromHistory;
    function generateScreenURL(moduleNameOrBaseURL, screenURLOrParameters, parameters) {
        var moduleName = moduleNameOrBaseURL;
        var screenURL = moduleNameOrBaseURL;
        var baseURL;
        if (typeof screenURLOrParameters === "string") {
            screenURL = screenURLOrParameters;
            baseURL = generateScreenURLWithModuleName(moduleName, screenURL, parameters);
        }
        else {
            parameters = screenURLOrParameters;
            moduleName = "";
            baseURL = generateGenericURL(screenURL, parameters);
        }
        return baseURL;
    }
    exports.generateScreenURL = generateScreenURL;
    function generateScreenURLWithModuleName(moduleName, screenURL, parameters) {
        var querystringParameters = selectQueryStringParameters(parameters, screenURL);
        var pathParameters = selectPathParameters(parameters, querystringParameters);
        detectEmptyValueOptionalParameterError(pathParameters, screenURL);
        return innerBuildURL(moduleName, screenURL, pathParameters, querystringParameters);
    }
    function generateGenericURL(baseURL, parameters) {
        var querystring = Object.keys(parameters)
            .map(function (key) { return "".concat(encodeURIComponent(key), "=").concat(encodeURIComponent(parameters[key])); })
            .join("&");
        var withQueryStringURL = "".concat(baseURL).concat(querystring.length > 0 ? "?".concat(querystring) : "");
        return withQueryStringURL;
    }
    function detectEmptyValueOptionalParameterError(paramMap, screenURL) {
        var tokens = pathToRegexp.parse(screenURL);
        var optTokensWithValues = tokens
            .filter(function (token) { return typeof token !== "string" && token.modifier === "?"; })
            .map(function (token) {
            var _a;
            return {
                name: token.name,
                value: (_a = paramMap[token.name]) !== null && _a !== void 0 ? _a : "",
            };
        });
        var hasEmptyValue = false;
        var emptyToken;
        optTokensWithValues.forEach(function (token) {
            if (hasEmptyValue && !isEmptyValue(token.value)) {
                throw new Error("Error processing optional parameters on path ".concat(screenURL, ". The parameter ").concat(emptyToken.name, " has an empty value while ").concat(token.name, " has a non-empty value. All optional parameters before ").concat(token.name, " must have a value when ").concat(token.name, " has a value."));
            }
            if (isEmptyValue(token.value)) {
                emptyToken = token;
                hasEmptyValue = true;
            }
        });
    }
    function isEmptyValue(value) {
        return value === "" || value === null || value === undefined;
    }
    function innerBuildURL(moduleName, screenURL, parameters, querystringParameters) {
        var querystring = Object.keys(querystringParameters)
            .map(function (key) { return "".concat(encodeURIComponent(key), "=").concat(encodeURIComponent(querystringParameters[key])); })
            .join("&");
        try {
            var toPath = pathToRegexp.compile(screenURL, {
                encode: function (value) { return encodeURIComponent(value); },
                validate: false,
            });
            var filledParamsURL = toPath(parameters);
            var withQueryStringURL = "".concat(filledParamsURL).concat(querystring.length > 0 ? "?".concat(querystring) : "");
            return generateBaseUrl(moduleName, withQueryStringURL);
        }
        catch (e) {
            var regexResult = new RegExp("^Expected \"(.*)\" to be a string$", "g").exec(e.message);
            if (regexResult) {
                var parameterName = regexResult[1];
                var message = "Error building URL for ".concat(screenURL, ". Parameter ").concat(parameterName, " is missing or has an empty value");
                Logger.error(moduleName, message);
                return undefined;
            }
            throw e;
        }
    }
    function selectQueryStringParameters(paramMap, screenURL) {
        var tokens = pathToRegexp.parse(screenURL);
        return Object.keys(paramMap)
            .filter(function (key) { return !tokens.some(function (token) { return typeof token !== "string" && token.name === key; }); })
            .reduce(function (obj, key) {
            obj[key] = paramMap[key];
            return obj;
        }, {});
    }
    function selectPathParameters(paramMap, queryStringParamMap) {
        return Object.keys(paramMap)
            .filter(function (key) { return paramMap[key] !== "" && !(key in queryStringParamMap); })
            .reduce(function (obj, key) {
            obj[key] = paramMap[key];
            return obj;
        }, {});
    }
    function buildApplicationRelativeUrl(parts, _a) {
        if (parts === void 0) { parts = []; }
        var _b = _a === void 0 ? {} : _a, _c = _b.getBasePath, getBasePath = _c === void 0 ? ApplicationInfo.getBasePath : _c;
        var baseURL = parts.length === 0 ? getBasePath() : "/" + parts.join("/");
        return baseURL.replace(DOUBLE_SLASH_REGEX, "/");
    }
    exports.buildApplicationRelativeUrl = buildApplicationRelativeUrl;
    function generateBaseUrl(moduleName, baseURL) {
        var basePath = ApplicationInfo.getBasePath();
        var baseURLStartWithNoSlash = baseURL.replace(/^\//, "");
        var homeModuleName = ApplicationInfo.getHomeModuleName();
        if (moduleName === homeModuleName) {
            return "".concat(basePath).concat(baseURLStartWithNoSlash);
        }
        else {
            return "/".concat(moduleName, "/").concat(baseURLStartWithNoSlash);
        }
    }
    var VersionedURL;
    (function (VersionedURL) {
        var urlVersionProvider = function (relativeUrl) { return relativeUrl; };
        function setUrlVersionProvider(provider) {
            urlVersionProvider = provider;
        }
        VersionedURL.setUrlVersionProvider = setUrlVersionProvider;
        function getVersionedUrl(baseUrl) {
            return urlVersionProvider(baseUrl);
        }
        VersionedURL.getVersionedUrl = getVersionedUrl;
    })(VersionedURL || (exports.VersionedURL = VersionedURL = {}));
});
//# sourceMappingURL=Navigation.js.map;
